import script from "./PointeusesIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./PointeusesIndex.vue?vue&type=script&setup=true&lang=js"

import "./PointeusesIndex.vue?vue&type=style&index=0&id=f873314c&lang=css"

const __exports__ = script;

export default __exports__